<template>
  <v-sheet class="py-10 catalog-page-list px-3 px-md-0">
    <div class="text-h4 text-center mb-8 ubuntu">Catálogos</div>

    <v-list-item
      class="rounded page-catalog-list-item mt-5"
      v-for="({ title, img, file, brand }, i) in items"
      :key="i"
    >
      <v-list-item-icon>
        <img class="page-catalogs-img" :src="files + img" alt="" />
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title
          class="font-weight-bold"
          v-text="title"
        ></v-list-item-title>
        <v-list-item-subtitle v-text="brand.title"></v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          rounded
          class="text-none"
          target="_blank"
          color="primary"
          depressed
          :href="files + file"
          >Download</v-btn
        >
      </v-list-item-action>
    </v-list-item>
  </v-sheet>
</template>

<script>
const _config = {
  mod: "catalogs",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get();
  },
};
</script>

<style>
.catalog-page-list {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
}
</style>
